import { addMonths, format, startOfMonth } from 'date-fns';

import { MonthlyPlannedWithdrawals, WithdrawalStatus } from '@ndvr/portfolio-api';

export const getWithdrawalPlanRange = (upcoming: boolean, today: Date) => {
    const start = upcoming ? startOfMonth(today) : new Date(today.getFullYear(), 0, 1);
    const end = addMonths(start, 11);
    return { startMonth: format(start, 'yyyy-MM'), endMonth: format(end, 'yyyy-MM') };
};

export const summarizeWithdrawalPlan = (months: MonthlyPlannedWithdrawals[], upcoming: boolean) => {
    let count = 0;
    let paidCount = 0;
    const bars = months.map((month) => {
        let paid = 0;
        let pending = 0;
        for (const withdrawal of month.withdrawals) {
            if (withdrawal.withdrawalStatus === WithdrawalStatus.CANCELED) continue;
            const completed = withdrawal.withdrawalStatus === WithdrawalStatus.COMPLETED;
            if (upcoming && completed) continue;
            count++;
            const amount = Number(withdrawal.finalAmount);
            if (completed) {
                paid += amount;
                paidCount++;
            } else {
                pending += amount;
            }
        }
        return { yearMonth: month.yearMonth, paid, pending, total: paid + pending };
    });
    return {
        bars,
        count,
        paidCount,
        total: bars.reduce((sum, bar) => sum + bar.total, 0),
        paid: bars.reduce((sum, bar) => sum + bar.paid, 0),
    };
};
